function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useContext } from 'react';
import { clearAllBodyScrollLocks } from 'body-scroll-lock';
import { UniversalAnalyticsContext, getRequiredCustomDimsForProperty } from '@zillow/universal-analytics-react';
import SearchInputWithButton from './SearchInputWithButton';
import ErrorBox from './ErrorBox';
import HomeDetailLightbox from './HomeDetailLightbox';
import { trackHmimhwPropertySearchDisplay, trackHmimhwPropertySearchError, trackAddressSearch } from '../utils/gaUtils';
import PropertySearch from '@zillow/property-search';
import { useYieldCallback } from '@zillow/yield-callback';
import { convertToLowerCaseParams } from '../utils/urlUtils';
import { getCurrentURLParams } from '../utils/windowUtils';

var PropertySearchWrapper = function PropertySearchWrapper(_ref) {
  var _ref$publicConfigValu = _ref.publicConfigValues,
      addressAutocompleteURL = _ref$publicConfigValu.addressAutocompleteURL,
      zatlasEndpoint = _ref$publicConfigValu.zatlasEndpoint,
      placementId = _ref.placementId,
      surfaceId = _ref.surfaceId,
      xConsumerUsername = _ref.xConsumerUsername,
      _ref$isLightboxBackgr = _ref.isLightboxBackgroundLocked,
      isLightboxBackgroundLocked = _ref$isLightboxBackgr === void 0 ? false : _ref$isLightboxBackgr,
      isCMS = _ref.isCMS,
      setIsLightboxOpen = _ref.setIsLightboxOpen,
      handleLightBoxDirectHit = _ref.handleLightBoxDirectHit,
      setRequiredCustomDimensions = _ref.setRequiredCustomDimensions;
  clearAllBodyScrollLocks();

  var _useContext = useContext(UniversalAnalyticsContext),
      areRequiredDimensionsSet = _useContext.areRequiredDimensionsSet;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      zpid = _useState2[0],
      setZpid = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isLightBoxDirectHit = _useState4[0],
      setIsLightBoxDirectHit = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      alreadyDirectAutoOpen = _useState6[0],
      setAlreadyDirectAutoOpen = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      hmimhwAnalyticsData = _useState8[0],
      setHmimhwAnalyticsData = _useState8[1];

  useEffect(function () {
    var params = convertToLowerCaseParams(new URLSearchParams(getCurrentURLParams()));
    var urlZpid = params.get('zpid');
    var isInitialized = false;

    if (!isLightBoxDirectHit && !!urlZpid) {
      setIsLightBoxDirectHit(!!urlZpid);
      setZpid(urlZpid);
      isInitialized = true;
    }

    if (hmimhwAnalyticsData) {
      setRequiredCustomDimensions(getRequiredCustomDimsForProperty({
        property: hmimhwAnalyticsData.property,
        abTests: hmimhwAnalyticsData.abTests
      }));
    }

    setIsLightboxOpen === null || setIsLightboxOpen === void 0 ? void 0 : setIsLightboxOpen(!!zpid);

    if (!zpid && !areRequiredDimensionsSet && !isInitialized) {
      trackHmimhwPropertySearchDisplay(placementId, surfaceId);
    } // only fire handleLightBoxDirectHit
    // if directly hitting the hmimhw page with the Review lightbox


    if (isLightBoxDirectHit && handleLightBoxDirectHit && zpid && hmimhwAnalyticsData && areRequiredDimensionsSet && !alreadyDirectAutoOpen) {
      handleLightBoxDirectHit();
      setAlreadyDirectAutoOpen(true);
    }
  }, [surfaceId, placementId, setIsLightboxOpen, zpid, areRequiredDimensionsSet, hmimhwAnalyticsData, handleLightBoxDirectHit, alreadyDirectAutoOpen, setRequiredCustomDimensions, isLightBoxDirectHit]);
  var onError = useYieldCallback(function (error) {
    return trackHmimhwPropertySearchError(placementId, surfaceId, error);
  });
  var handleAddressSelect = useYieldCallback(function (params) {
    if (params.zpid) {
      trackAddressSearch(params.surfaceId || surfaceId, params.placementId || placementId);
      setZpid(params.zpid);
    }
  }, [placementId, surfaceId]);

  if (zpid && typeof document !== 'undefined') {
    return /*#__PURE__*/React.createElement("div", {
      className: "scrollTarget",
      "data-testid": "hmimhw-home-detail-lightbox"
    }, /*#__PURE__*/React.createElement(HomeDetailLightbox, {
      zpid: zpid,
      setZpid: setZpid,
      zatlasEndpoint: zatlasEndpoint,
      surfaceId: surfaceId,
      placementId: placementId,
      xConsumerUsername: xConsumerUsername,
      isLightboxBackgroundLocked: isLightboxBackgroundLocked,
      isCMS: isCMS,
      setHmimhwAnalyticsData: setHmimhwAnalyticsData
    }));
  }

  return /*#__PURE__*/React.createElement(PropertySearch, {
    renderInput: function renderInput(props) {
      return SearchInputWithButton(Object.assign({
        handleAddressSelect: handleAddressSelect,
        placementId: placementId,
        surfaceId: surfaceId,
        options: props.options
      }, props));
    },
    renderEmptyState: null,
    onSubmit: handleAddressSelect,
    onError: onError,
    renderError: ErrorBox,
    addressAutocompleteUrl: addressAutocompleteURL
  });
};

export default PropertySearchWrapper;
//# sourceMappingURL=PropertySearchWrapper.js.map